import { IsDefined, IsInt, IsOptional, IsString } from 'class-validator';

export class OrderSourceStats {
  @IsDefined()
  @IsInt()
  id: number;

  @IsDefined()
  @IsString()
  name: string;

  @IsDefined()
  @IsInt()
  count: number;

  @IsOptional()
  @IsString()
  logoURL?: string;
}
